import { useEffect, useMemo } from 'react'

import { useUser } from 'src/providers/UserProvider'

import { useGetProductAndPricesLazyQuery } from 'src/config/generated/graphql'

export const useProductPrice = (
  quantity?: number,
  applyAccountOverride = false
): {
  productPrice: number
  productPriceLoading: boolean
  getProductPrice: (quantity: number) => void
} => {
  const { user } = useUser()
  const [
    getProductAndPrices,
    { data: productAndPricesData, loading: productAndPricesLoading }
  ] = useGetProductAndPricesLazyQuery()

  const productPrice: number = useMemo(() => {
    const { ProductPrices } = productAndPricesData?.Product?.[0] || {}
    const { Amount } = ProductPrices?.[0] || {}
    const tierPrice = Amount || 0

    const override = user?.Account?.PricePerTreeOverride
    if (applyAccountOverride && override != null) {
      return Number(override)
    }

    return tierPrice
  }, [
    productAndPricesData,
    user?.Account?.PricePerTreeOverride,
    applyAccountOverride
  ])

  const getProductPrice = (q: number) =>
    getProductAndPrices({
      variables: { quantity: q }
    })

  useEffect(() => {
    if (quantity) {
      getProductPrice(quantity)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quantity])

  return {
    productPrice,
    productPriceLoading: productAndPricesLoading,
    getProductPrice
  }
}
